/**
 * Button With Content Card Component goes within a reference card or info block section with an optional title, required content and button
 */
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from '../../Button';
const defaultProps = {
  brand: 'law',
  heading: null,
  content: null,
  subContent: null,
  buttonLabel: '',
  buttonType: 'primary',
  url: '',
  anchorLink: null
};

/**
 * Button With Content React Component
 *
 * @param  {string} brand => The brand
 * @param  {node} heading => The content title, optional
 * @param  {node} content => The content text, required
 * @param  {node} subContent => Additional content text (below the button), optional
 * @param  {string} buttonLabel => The text displayed within the button
 * @param  {string} buttonType => The button variant, primary and secondary
 * @param  {string} url => The url which clicking the button will take the user
 * @param  {node} anchorLink => A gatsby anchor link if the link is to an id in contentful
 */
const ButtonWithContentCard = _ref => {
  let {
    brand,
    heading,
    content,
    subContent,
    buttonLabel,
    buttonType,
    url,
    anchorLink
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "button-card",
    className: "button-card d-flex flex-column h-100"
  }, heading && /*#__PURE__*/React.createElement(Row, {
    className: "mx-0 px-lg-5 px-lg-5 flex-fill button-card-title"
  }, /*#__PURE__*/React.createElement(Col, {
    "data-testid": "content-title",
    className: "text-center card-title-wrap"
  }, heading)), content && /*#__PURE__*/React.createElement(Row, {
    className: "mx-0 px-lg-5 px-lg-5 flex-fill"
  }, /*#__PURE__*/React.createElement(Col, {
    "data-testid": "content-text",
    className: "text-center"
  }, content)), /*#__PURE__*/React.createElement(Row, {
    className: "mx-0 justify-content-center flex-fill button-card-btn"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 10
  }, anchorLink || /*#__PURE__*/React.createElement("a", {
    href: url
  }, /*#__PURE__*/React.createElement(Button, {
    brand: brand,
    label: buttonLabel,
    variant: buttonType
  })))), subContent && /*#__PURE__*/React.createElement(Row, {
    className: "mx-0 px-lg-5 px-lg-5 flex-fill"
  }, /*#__PURE__*/React.createElement(Col, {
    "data-testid": "content-subcontent",
    className: "text-center"
  }, subContent)));
};
ButtonWithContentCard.defaultProps = defaultProps;
export { ButtonWithContentCard };